
import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative h-screen w-full overflow-hidden bg-[#0A1628]">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/6642ba5e3e72aabdca47beb152767131.jpg"
          alt="Cr.edit Publishing Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628]/70 via-[#0A1628]/60 to-[#0A1628]/70"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-7xl mx-auto px-6 w-full">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-white font-serif mb-8">
              <div className="text-6xl md:text-7xl font-bold mb-6 animate-fade-in">
                Cr.edit
              </div>
              <div className="text-3xl md:text-4xl font-medium mb-8 animate-fade-in" style={{ animationDelay: '0.2s' }}>
                삶의 모호함 위에 선명한 '점(.)'을 찍는 출판, 크레딧입니다.
              </div>
            </h1>
            
            <p className="text-white/90 text-xl mb-12 leading-relaxed animate-fade-in" style={{ animationDelay: '0.4s' }}>
              쏟아지는 정보 속에서 길을 잃은 당신에게,<br />
              흔들리지 않는 기준과 새로운 시작의 계기를 선물합니다.
            </p>
            
            <div className="flex flex-wrap items-center justify-center gap-4 animate-fade-in" style={{ animationDelay: '0.6s' }}>
              <a
                href="mailto:dahae@creditworks.co.kr"
                className="inline-flex items-center gap-3 bg-[#D4AF37] text-[#0A1628] px-8 py-4 rounded-full text-base font-bold hover:bg-[#F4D03F] transition-all hover:gap-4 cursor-pointer whitespace-nowrap"
              >
                원고 투고하기
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
